export class User {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    roleId: string;
    role: string; 
    superior: string;
    name: string;
    password: string;
    repeatedPassword: string;
    isActive: boolean;
    layoutThemeName: string;
    picture: string;
    phoneNumber: string;
    employeeId: number;
    numeratorSerie: string;
    employee: string;
    login: string;
    isForeignEmployee: boolean;
    department: string;
    deactivatedBy: string;
    deactivateDate: Date;
}

export class UserPositionRow {
    id: Int32Array;
    userId: string;
    dateFrom: string;
    dateTo: string;
    salary: number;
    roleName: string;
    userRoleId: string;
}